import { withNavigation }         from 'components/App/withNavigation';
import { WithNavigationProps }    from 'components/App/withNavigation';
import React                      from 'react';
import { Button }                 from 'antd';
import { observer }               from 'mobx-react';
import { Popconfirm }             from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { computed }               from 'mobx';
import { PagedCollection }        from 'collections/PagedCollection';
import AdvertiserModel            from 'models/AdvertiserModel';
import currentSession             from 'utils/currentSession';
import { messageErrorIntl }       from 'utils/messageIntl';
import { messageSuccessIntl }     from 'utils/messageIntl';
import FormattedMessageWrapper    from 'components/App/FormattedMessageWrapper';
import Search                     from 'components/App/IntlSearch';
import ListComponent              from 'components/App/ListComponent';
import { AppForm }                from 'components/App/AppForm';
import AdvertiserForm             from 'forms/AdvertiserForm';

const LogoStyle = {
  backgroundPosition: 'center',
  backgroundSize: '100% auto',
  height: '75px',
  overflow: 'hidden',
  width: '75px',
};

const openAdvertiserForm = (model: AdvertiserModel, onSuccess: () => void) => {
  const title = model.id
    ? <FormattedMessageWrapper id="Modifier un annonceur" />
    : <FormattedMessageWrapper id="Ajouter un annonceur" />;

  AppForm.open(AdvertiserForm, { model, onSuccess }, { title });
};

@observer
class AdvertiserList extends React.Component<WithNavigationProps> {
  public advertiserCollection = new PagedCollection(AdvertiserModel);

  public componentDidMount() {
    if (!currentSession.isAdmin) {
      this.props.navigate('/404');
    }
  }

  public render() {
    return (
      <ListComponent
        collection={this.advertiserCollection}
        columns={this.columns}
        fetchData={this.fetchData}
        loading={!this.advertiserCollection.isLoaded || this.advertiserCollection.isLoading}
        onRowClick={modelId => {
          this.props.navigate(`/annonceurs/${modelId}`);
        }}
        rowSelection={false}
        title={<FormattedMessageWrapper id="Annonceurs" />}
        topRightWidget={this.renderTopRightWidget()}
      />
    );
  }

  public renderTopRightWidget = () => (
    <>
      <Search
        onSearch={this.onSearch}
        placeholder="Rechercher un annonceur"
        style={{ width: 200 }}
      />
      &nbsp;
      <Button
        htmlType="button"
        onClick={() => openAdvertiserForm(new AdvertiserModel(), () => this.advertiserCollection.list())}
      >
        <FormattedMessageWrapper id="Ajouter un annonceur" />
      </Button>
    </>
  );

  private deleteAdvertiser = async (advertiserId: id) => {
    const advertiserToDelete = new AdvertiserModel();
    advertiserToDelete.set('id', advertiserId);
    try {
      await advertiserToDelete.destroy();
      messageSuccessIntl("Annonceur supprimé !");
      this.advertiserCollection.list();
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };

  private fetchData = async (pagination?: any, filters?: any, sorter?: any) => {
    this.advertiserCollection.setPage(pagination?.current || 1);
    this.advertiserCollection.filters = {};

    Object.keys(filters || {}).forEach(filterName => {
      this.advertiserCollection.setFilter(filterName, filters[filterName]);
    });

    this.advertiserCollection.sorts = {};

    if (sorter?.order) {
      this.advertiserCollection.setSort(sorter.field, sorter.order === 'ascend');
    }

    try {
      await this.advertiserCollection.list();
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };

  private onSearch = (value?: string) => {
    this.fetchData(
      { current: 1 },
      { ...this.advertiserCollection.filters, search: value },
      this.advertiserCollection.sorts,
    );
  };

  @computed
  get columns() {
    return [
      {
        intlTitle: 'Nom',
        property: 'name',
        render: (model: AdvertiserModel) => model.advertiserName,
        sorter: true,
      },
      {
        intlTitle: 'Lien',
        property: 'link',
        render: (model: AdvertiserModel) => model.link,
        sorter: true,
      },
      {
        intlTitle: 'Logo',
        property: 'logo',
        render: (model: AdvertiserModel) => (
          <div
            style={{
              ...LogoStyle,
              backgroundImage: `url(${model.logoObjectUrl})`,
            }}
          />
        ),
      },
      {
        intlTitle: 'Clics',
        property: 'counter',
        render: (model: AdvertiserModel) => model.counter,
        sorter: true,
      },
      {
        intlTitle: 'Actions',
        property: 'actions',
        render: (model: AdvertiserModel) => (
          <>
            <Button
              htmlType="button"
              onClick={event => {
                event.stopPropagation();
                openAdvertiserForm(model, () => this.advertiserCollection.list());
              }}
            >
              <FormattedMessageWrapper id="Modifier" />
            </Button>
            &nbsp;
            <Popconfirm
              cancelText={<FormattedMessageWrapper id="Non" />}
              icon={<QuestionCircleOutlined style={{ color: '#e74c3c' }} />}
              okText={<FormattedMessageWrapper id="Oui" />}
              onCancel={event => event?.stopPropagation()}
              onConfirm={async event => {
                event?.stopPropagation();
                await this.deleteAdvertiser(model.id);
              }}
              placement="left"
              title={
                <FormattedMessageWrapper id="Êtes-vous sûr de vouloir supprimer cet annonceur ?" />
              }
            >
              <Button
                htmlType="button"
                onClick={event => event.stopPropagation()}
              >
                <FormattedMessageWrapper id="Supprimer" />
              </Button>
            </Popconfirm>
          </>
        ),
      },
    ];
  }
}

const WrappedAdvertiserList = withNavigation(AdvertiserList);

export default WrappedAdvertiserList;
